<style scoped>
    .block{
        margin-top: .2rem;
        background: #ffff;
    }
    .imgBox{
        padding: 0 .24rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 1.4rem;
        color: #2C2C2C;
        font-size: .3rem;
        border-bottom: .01rem solid #E5E5E5;
    }
    .img{
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        background: #000;
    }
    .itemBox{
        padding: .38rem .24rem;
        display: flex;
        justify-content: space-between;
        border-bottom: .01rem solid #E5E5E5;
        font-size: .3rem;
        color: #2C2C2C;
        line-height: .42rem;
    }
    .itemBox span{
        color: #010101;
        max-width: 4rem;

    }
    .block .itemBox:last-child{
        border-bottom: 0;
    }
</style>
<template>
    <div style="padding-top: .98rem">
        <topbar text="我的资料"></topbar>
        <div class="block">
            <div class="imgBox">
                头像 <div class="img" :style="avatarImg()"></div>
            </div>
            <div class="itemBox">
                姓名
                <span>{{doctorInfo.doctorName}}</span>
            </div>
            <div class="itemBox">
                手机号
                <span>{{doctorInfo.doctorPhone}}</span>
            </div>
        </div>
        <div class="block">
            <div class="itemBox">
                从业资质
                <span>{{doctorInfo.doctorHospitalLevel}}</span>
            </div>
            <div class="itemBox">
                咨询师介绍
                <span v-html="doctorInfo.doctorProfile"></span>
            </div>
        </div>

    </div>
</template>
<script>
    import {getSource, getSources} from "../api"
    import {getImage} from "@/utils"

    import noMoreData from 'components/no-more-data'
    import topbar from 'components/topbar'
    import moment from 'moment/moment'

    import {serialize} from 'utils/index'

    export default {
        data() {
            return {
//                EnvUrl: `https://oml9ntix5.qnssl.com/`, // 七牛图片
                EnvUrl: `https://cdn.ysqingxin.com/`,
                doctorInfo:{},
            }
        },
        components: {
            noMoreData,
            topbar,
        },
        filters: {

            time(value) {
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },
        },
        computed: {},
        methods: {
            async scaleDoctorHome() {
                let data = await getSources("/bear-scale/api/chatDoctor/getDoctorInfo.json",{doctorId:localStorage.getItem('doctorId')});
                if (data.status === 0) {
                    this.doctorInfo = data.doctorInfo
                }else{
                    alert(data.msg)
                }
            },
          avatarImg() {
              const img = getImage(this.doctorInfo.doctorWorkPhoto)
              return {background: `url(${img}) no-repeat center/cover`}
          }

        },
        destroyed(){

        },
        mounted() {
            this.scaleDoctorHome()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/personalData.vue